import { PluginKey } from 'prosemirror-state'
import { Command } from 'common/Prose/Commands'

export const setMeta =
  (plugin: PluginKey, value: any): Command =>
  (state, dispatch) => {
    if (!dispatch) {
      return false
    }

    const tr = state.tr
    tr.setMeta(plugin, value)
    dispatch(tr)

    return true
  }
